export default __webpack_public_path__ + "static/media/word-of-mouth.6ece300d.svg";